import type { JSX } from 'react';
import type { Palette } from '../../../_theme/palette.js';
import { hexWithAlpha } from '../../../_theme/palette.js';
import { TextField } from '../../../_components/TextField.js';
import type { SurveyIdentityConfig } from '../types.js';

interface IdentityGateProps {
  palette: Palette;
  identityConfig: SurveyIdentityConfig | undefined;
  email: string;
  onEmailChange: (value: string) => void;
}

export function IdentityGate({ palette, identityConfig, email, onEmailChange }: IdentityGateProps): JSX.Element {
  const required = identityConfig?.mode === 'emailRequired';
  const label = identityConfig?.emailLabel ?? 'Your email';

  return (
    <div
      style={{
        background: palette.card,
        border: `1px solid ${hexWithAlpha(palette.textMuted, 0.13)}`,
        borderRadius: 12,
        padding: 20,
      }}
    >
      <label style={{ display: 'block', marginBottom: 8, color: palette.text, fontSize: 15, fontWeight: 600 }}>
        {label}
        {required && <span style={{ color: '#dc2626', marginLeft: 4 }}>*</span>}
      </label>
      {identityConfig?.emailHelpText && (
        <p style={{ color: palette.textMuted, fontSize: 13, margin: '0 0 8px' }}>{identityConfig.emailHelpText}</p>
      )}
      <TextField
        palette={palette}
        type="email"
        value={email}
        onChange={onEmailChange}
        placeholder="you@example.com"
        ariaLabel={label}
      />
    </div>
  );
}
